import LoadingIcon from "components/Loading/LoadingIcon";
import Swimlane, { SwimlaneItem } from "components/Swimlane/Swimlane";

type MetaDocLoadingScreenProps = {
  message?: string;
};

const MetaDocLoadingScreen = ({
  message = "Loading Meta Document...",
}: MetaDocLoadingScreenProps) => {
  return (
    <Swimlane>
      <SwimlaneItem heading="Meta Document">
        <div className="metadoc-empty-state">
          <LoadingIcon message={message} />
        </div>
      </SwimlaneItem>
    </Swimlane>
  );
};

export default MetaDocLoadingScreen;
